import type { OHLCVPoint } from '../../api/types';
import type { ChartSeries } from '../../event/chart/seriesTypes';

export function hasVolume(points: readonly OHLCVPoint[]): boolean {
    return points.some(p => p.vol > 0);
}

export function volumeSeries(
    points: readonly OHLCVPoint[],
    color: string
): ChartSeries {
    return {
        id: 'volume',
        label: 'Volume',
        color,
        unit: 'shares',
        draw: 'bars',
        axis: 'hidden',
        home: 'probability',
        movable: false,
        hasData: hasVolume(points),
        data: {
            kind: 'points',
            points: points.map(p => ({ t: p.t.getTime(), v: p.vol || 0 })),
        },
    };
}
